<div class="home">
  <div class="info">
    <h1>What are you cooking today?</h1>
    <h2>
      Explore easy recipes shared by the people around world or share your own
      recipe.
    </h2>
    <div class="search">
      <div class="wrapper">
        <input type="text" placeholder="Eg. pizza, sushi" />
        <button class="mainBtn black">Search</button>
      </div>
    </div>
  </div>
</div>
<div class="section categories">
  <div class="title">Popular categories</div>
  <div class="content">
    <button>
      <div class="cover">
        <img src="assets/categories/pizza.jpg" alt="" />
      </div>
      <div class="name">Pizza</div>
    </button>
    <button>
      <div class="cover">
        <img src="assets/categories/burger.jpg" alt="" />
      </div>
      <div class="name">Burger</div>
    </button>
    <button>
      <div class="cover">
        <img src="assets/categories/salad.jpg" alt="" />
      </div>
      <div class="name">Salad</div>
    </button>
    <button>
      <div class="cover">
        <img src="assets/categories/noodles.jpg" alt="" />
      </div>
      <div class="name">Noodles</div>
    </button>
    <button>
      <div class="cover">
        <img src="assets/categories/fried_rice.jpg" alt="" />
      </div>
      <div class="name">Fried rice</div>
    </button>
    <button>
      <div class="cover">
        <img src="assets/categories/soup.jpg" alt="" />
      </div>
      <div class="name">Soup</div>
    </button>
    <button>
      <div class="cover">
        <img src="assets/categories/juice.jpg" alt="" />
      </div>
      <div class="name">Juice</div>
    </button>
  </div>
</div>

<div class="section recipes">
  <div class="title">Most loved</div>
  <div class="content">
    <button routerLink="/111/aaa" class="recipeCard">
      <div class="cover">
        <img src="assets/categories/pizza.jpg" alt="" />
      </div>
      <!-- <button class="bookmark">
        <ion-icon name="bookmark-outline"></ion-icon>
      </button> -->
      <div class="wrapper">
        <div class="info">
          <div class="name">Cheese Pizza</div>
          <div class="calories">14 calories</div>
        </div>
        <div class="meta">
          <div>
            <div>Time</div>
            <div>45 mins</div>
          </div>
          <div>
            <div>Portion</div>
            <div>3 persons</div>
          </div>
        </div>
        <div class="counts">
          <div class="likes"><ion-icon name="heart-outline"></ion-icon> 92</div>
          <div class="chat">
            <ion-icon name="chatbox-ellipses-outline"></ion-icon> 11
          </div>
          <div class="ratings">
            <ion-icon name="star-outline"></ion-icon> 203
          </div>
        </div>
      </div>
    </button>
    <button routerLink="/111/aaa" class="recipeCard">
      <div class="cover">
        <img src="assets/categories/juice.jpg" alt="" />
      </div>
      <div class="wrapper">
        <div class="info">
          <div class="name">New York Cheesecake Recipe</div>
          <div class="calories">33 calories</div>
        </div>
        <div class="meta">
          <div>
            <div>Time</div>
            <div>32 mins</div>
          </div>
          <div>
            <div>Portion</div>
            <div>1 persons</div>
          </div>
        </div>
        <div class="counts">
          <div class="likes"><ion-icon name="heart-outline"></ion-icon> 92</div>
          <div class="chat">
            <ion-icon name="chatbox-ellipses-outline"></ion-icon> 11
          </div>
          <div class="ratings">
            <ion-icon name="star-outline"></ion-icon> 203
          </div>
        </div>
      </div>
    </button>
    <button routerLink="/111/aaa" class="recipeCard">
      <div class="cover">
        <img src="assets/categories/burger.jpg" alt="" />
      </div>
      <div class="wrapper">
        <div class="info">
          <div class="name">Baked Chicken Burgers Recipe</div>
          <div class="calories">25 calories</div>
        </div>
        <div class="meta">
          <div>
            <div>Time</div>
            <div>25 mins</div>
          </div>
          <div>
            <div>Portion</div>
            <div>5 persons</div>
          </div>
        </div>
        <div class="counts">
          <div class="likes"><ion-icon name="heart-outline"></ion-icon> 92</div>
          <div class="chat">
            <ion-icon name="chatbox-ellipses-outline"></ion-icon> 11
          </div>
          <div class="ratings">
            <ion-icon name="star-outline"></ion-icon> 203
          </div>
        </div>
      </div>
    </button>
    <button routerLink="/111/aaa" class="recipeCard">
      <div class="cover">
        <img src="assets/categories/fried_rice.jpg" alt="" />
      </div>
      <div class="wrapper">
        <div class="info">
          <div class="name">Unique Chicken Biryani Recipe</div>
          <div class="calories">42 calories</div>
        </div>
        <div class="meta">
          <div>
            <div>Time</div>
            <div>55 mins</div>
          </div>
          <div>
            <div>Portion</div>
            <div>2 persons</div>
          </div>
        </div>
        <div class="counts">
          <div class="likes"><ion-icon name="heart-outline"></ion-icon> 92</div>
          <div class="chat">
            <ion-icon name="chatbox-ellipses-outline"></ion-icon> 11
          </div>
          <div class="ratings">
            <ion-icon name="star-outline"></ion-icon> 203
          </div>
        </div>
      </div>
    </button>
  </div>
</div>
